import * as Utils from '../utils/util';
import CreateFrontData from './createFrontData';
import { Dep } from '../observe/index';
import { __dataSetProxy__, __depSet__ } from './db';

export function add(cube: CubeNode): void {
    let depMap: DepMap = {};
    let srcData = CreateFrontData(cube);
    let proxy = new Proxy(srcData, {
        get(target: any, key: any) {
            if (!(key in depMap)) {
                depMap[key] = {
                    dep: new Dep(),
                    lastValue: target[key],
                    currentValue: target[key]
                };
            }

            if (Dep.target) {
                let keyDep: any = depMap[key];

                keyDep.dep.depend();
            }

            return target[key];
        },

        set(target: any, key: string, value: any): boolean {
            target[key] = value;

            if (depMap[key]) {
                depMap[key].currentValue = value;
            }
            return true;
        }
    });
    __dataSetProxy__(cube.id, proxy);
    __depSet__(cube.id, depMap);

    // 容错处理，兼容老逻辑(使不报错)，画布中不会从这里取数据
    cube.frontCubeData = Utils.deepCopy(srcData);
}
